module.exports = __webpack_public_path__ + "static/media/pune to banglore.ce14a8c8.jpg";